import React from 'react';

const GridOverlay = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'background.paper', // Semi-transparent background
    zIndex: 10,
    fontSize: '12px',
    color: '#666',
  }}>
    <p>No Records Found</p>
  </div>
);

export default GridOverlay;
